function buildId(dimension) {
    return `${dimension.country}_${dimension.brand}_dataLayer`;
}
export const toggleDataLayer = {
    get: (dimension) => {
        return JSON.parse(localStorage.getItem(buildId(dimension)) ?? 'null');
    },
    set: (dimension, value) => {
        localStorage.setItem(buildId(dimension), JSON.stringify(value));
    },
};
//# sourceMappingURL=toggleDataLayer.js.map